import {
  Accessibility,
  ActivityIcon,
  AlertCircle,
  AlertTriangleIcon,
  AnchorIcon,
  AppleIcon,
  ArrowBigLeftIcon,
  ArrowBigRightIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowRightLeftIcon,
  ArrowUpDownIcon,
  ArrowUpIcon,
  ArrowUpRightFromSquareIcon,
  AtSignIcon,
  BadgeCheckIcon,
  BadgeIcon,
  BadgeInfoIcon,
  BaggageClaimIcon,
  BanIcon,
  BatteryFullIcon,
  BellRingIcon,
  BriefcaseBusinessIcon,
  BriefcaseMedicalIcon,
  Building2,
  CakeIcon,
  CalendarClockIcon,
  CalendarDaysIcon,
  CalendarIcon,
  CalendarRange,
  Check,
  ChevronDownIcon,
  ChevronFirstIcon,
  ChevronLastIcon,
  ChevronLeft,
  ChevronRight,
  ChevronUpIcon,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDownIcon,
  CircleArrowRight,
  CircleCheckBigIcon,
  CircleCheckIcon,
  CircleDashed,
  CircleDashedIcon,
  CircleDollarSignIcon,
  CircleDotDashedIcon,
  CircleDotIcon,
  CircleFadingPlusIcon,
  CircleHelpIcon,
  CircleIcon,
  CircleOffIcon,
  CirclePauseIcon,
  CirclePlay,
  CircleSlash2,
  CircleStop,
  CircleUserRoundIcon,
  CircleXIcon,
  CircuitBoardIcon,
  ClipboardListIcon,
  ClipboardXIcon,
  Code2Icon,
  ConstructionIcon,
  ContactRound,
  CopyIcon,
  CornerDownLeftIcon,
  CpuIcon,
  DatabaseBackup,
  DatabaseZapIcon,
  DoorClosedIcon,
  DotIcon,
  Download,
  DropletIcon,
  EditIcon,
  EllipsisIcon,
  Expand,
  ExternalLinkIcon,
  Eye,
  EyeOff,
  FileCheckIcon,
  FilePenIcon,
  FilePenLineIcon,
  FileSpreadsheet,
  FileTextIcon,
  FileUpIcon,
  FileXIcon,
  FlagTriangleRightIcon,
  FolderInputIcon,
  FolderKeyIcon,
  FolderOpenIcon,
  FolderTreeIcon,
  FunctionSquareIcon,
  GaugeIcon,
  Gem,
  GitCompareIcon,
  GripVerticalIcon,
  Hammer,
  HandshakeIcon,
  HardDriveIcon,
  HashIcon,
  HeartMinusIcon,
  HeartPulseIcon,
  HelpCircleIcon,
  HistoryIcon,
  HomeIcon,
  IdCardIcon,
  ImageIcon,
  ImageUpIcon,
  ImportIcon,
  InfoIcon,
  IterationCw,
  KeyRoundIcon,
  LandPlotIcon,
  LaptopIcon,
  LayersIcon,
  LayoutGridIcon,
  LinkIcon,
  Table2Icon,
  ListCheckIcon,
  ListFilterIcon,
  ListIcon,
  ListOrderedIcon,
  ListPlusIcon,
  ListXIcon,
  Loader2Icon,
  LoaderCircleIcon,
  LogOutIcon,
  Mail,
  MapPin,
  MapPinned,
  MemoryStickIcon,
  MinusIcon,
  MonitorIcon,
  MonitorSmartphoneIcon,
  MoreHorizontalIcon,
  MoreVerticalIcon,
  MouseIcon,
  MoveDownRightIcon,
  MoveRightIcon,
  MoveUpRightIcon,
  NetworkIcon,
  PackageMinusIcon,
  PackageOpen,
  PackagePlusIcon,
  PanelLeftCloseIcon,
  PanelLeftOpenIcon,
  Paperclip,
  PencilIcon,
  Phone,
  PlaneLandingIcon,
  PlaneTakeoffIcon,
  PlusCircle,
  PlusIcon,
  PointerIcon,
  PrinterIcon,
  QrCodeIcon,
  RadioIcon,
  RecycleIcon,
  RedoDotIcon,
  RefreshCcwDotIcon,
  RefreshCwIcon,
  Repeat2Icon,
  RocketIcon,
  RouterIcon,
  SatelliteDishIcon,
  SaveIcon,
  ScanBarcodeIcon,
  SearchIcon,
  SearchSlashIcon,
  SearchXIcon,
  SendHorizontalIcon,
  SendIcon,
  ServerIcon,
  Settings2Icon,
  SettingsIcon as SettingsLucideIcon,
  Share2,
  ShieldCheckIcon,
  ShieldEllipsisIcon,
  ShieldIcon,
  ShieldXIcon,
  ShoppingCart,
  SlidersHorizontal,
  SmartphoneIcon,
  Square,
  SquareArrowOutUpRightIcon,
  SquareArrowUpRightIcon,
  SquareAsterisk,
  SquareCheckBig,
  SquareDot,
  SquareUser,
  StampIcon,
  StickyNoteIcon,
  StretchHorizontalIcon,
  TabletSmartphoneIcon,
  TagIcon,
  ThumbsUpIcon,
  Trash2Icon,
  TrendingDownIcon,
  TrendingUpIcon,
  TriangleAlertIcon,
  Truck,
  User2Icon,
  UserIcon,
  UserMinusIcon,
  UserPlusIcon,
  UserRoundCheckIcon,
  UserRoundCogIcon,
  UserRoundIcon,
  UserRoundMinusIcon,
  UserRoundPlusIcon,
  UserRoundSearchIcon,
  UserRoundXIcon,
  UsersRoundIcon,
  ViewIcon,
  WaypointsIcon,
  WrenchIcon,
  XIcon,
  XOctagonIcon,
} from "lucide-react";

import { ProductLogoSmallContracts, ProductLogoSmallPlaces } from "../Logo";
import {
  AccountIcon,
  AppsIcon,
  BoardMemberIcon,
  CollaboratorIcon,
  ContractorIcon,
  DevicesIcon,
  IncorrectRoleIcon,
  JobLevelIcon,
  NoLogoIcon,
  OperationTaskIcon,
  OrganizationIcon,
  OriginalManagerIcon,
  OriginalPlacementCheckIcon,
  OriginalRoleIcon,
  OsAndroidIcon,
  OsChromeIcon,
  OsLinuxIcon,
  OsMacosIcon,
  OsOthersIcon,
  OsWindowsIcon,
  PeopleIcon,
  PortAudioIcon,
  PortDisplayPortIcon,
  PortDviIcon,
  PortHdmiIcon,
  PortLanIcon,
  PortMiniDisplayPortIcon,
  PortThunderboltIcon,
  PortUsbMicroBIcon,
  PortUsbMiniIcon,
  PortUsbTypeAIcon,
  PortUsbTypeBIcon,
  PortUsbTypeCIcon,
  PortVgaIcon,
  ProductIcon,
  RoleIcon,
  SettingsIcon,
  StatusIcon,
  WorkArrangementIcon,
} from "./ForceIcons";
import { OriginalIdIcon } from "./ForceIcons/OriginalIdIcon";
import { LogicalAndIcon, LogicalOrIcon } from "./LogicalIcons";
import {
  MaterialContractIcon,
  MaterialInventoryIcon,
  MaterialQuickReferenceAll,
} from "./MaterialIcons";

export const IconMap = {
  Accessibility: Accessibility,
  AccountIcon: AccountIcon,
  ActivityIcon: ActivityIcon,
  AlertCircle: AlertCircle,
  AlertTriangleIcon: AlertTriangleIcon,
  AppleIcon: AppleIcon,
  AppsIcon: AppsIcon,
  AnchorIcon: AnchorIcon,
  ArrowBigLeftIcon: ArrowBigLeftIcon,
  ArrowBigRightIcon: ArrowBigRightIcon,
  ArrowDownIcon: ArrowDownIcon,
  ArrowLeftIcon: ArrowLeftIcon,
  ArrowRightIcon: ArrowRightIcon,
  ArrowRightLeftIcon: ArrowRightLeftIcon,
  ArrowUpDownIcon: ArrowUpDownIcon,
  ArrowUpIcon: ArrowUpIcon,
  ArrowUpRightFromSquareIcon: ArrowUpRightFromSquareIcon,
  AtSignIcon: AtSignIcon,
  BadgeCheckIcon: BadgeCheckIcon,
  BadgeIcon: BadgeIcon,
  BadgeInfoIcon: BadgeInfoIcon,
  BaggageClaimIcon: BaggageClaimIcon,
  BanIcon: BanIcon,
  BatteryFullIcon: BatteryFullIcon,
  BoardMemberIcon: BoardMemberIcon,
  BellRingIcon: BellRingIcon,
  BriefcaseBusinessIcon: BriefcaseBusinessIcon,
  BriefcaseMedicalIcon: BriefcaseMedicalIcon,
  Building2: Building2,
  CakeIcon: CakeIcon,
  CalendarClockIcon: CalendarClockIcon,
  CalendarDaysIcon: CalendarDaysIcon,
  CalendarIcon: CalendarIcon,
  CalendarRange: CalendarRange,
  Check: Check,
  ChevronDownIcon: ChevronDownIcon,
  ChevronFirstIcon: ChevronFirstIcon,
  ChevronLastIcon: ChevronLastIcon,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  ChevronsLeft: ChevronsLeft,
  ChevronsRight: ChevronsRight,
  ChevronsUpDownIcon: ChevronsUpDownIcon,
  ChevronUpIcon: ChevronUpIcon,
  CircleArrowRight: CircleArrowRight,
  CircleCheckBigIcon: CircleCheckBigIcon,
  CircleCheckIcon: CircleCheckIcon,
  CircleDashed: CircleDashed,
  CircleDashedIcon: CircleDashedIcon,
  CircleDollarSignIcon: CircleDollarSignIcon,
  CircleDotDashedIcon: CircleDotDashedIcon,
  CircleDotIcon: CircleDotIcon,
  CircleFadingPlusIcon: CircleFadingPlusIcon,
  CircleHelpIcon: CircleHelpIcon,
  CircleIcon: CircleIcon,
  CircleOffIcon: CircleOffIcon,
  CirclePauseIcon: CirclePauseIcon,
  CirclePlay: CirclePlay,
  CircleSlash2: CircleSlash2,
  CircleStop: CircleStop,
  CircleUserRoundIcon: CircleUserRoundIcon,
  CircleXIcon: CircleXIcon,
  CircuitBoardIcon: CircuitBoardIcon,
  ClipboardListIcon: ClipboardListIcon,
  ClipboardXIcon: ClipboardXIcon,
  Code2Icon: Code2Icon,
  CollaboratorIcon: CollaboratorIcon,
  ConstructionIcon: ConstructionIcon,
  ContactRound: ContactRound,
  Contract: MaterialContractIcon,
  ContractProductLogoSmall: ProductLogoSmallContracts,
  ContractorIcon: ContractorIcon,
  CopyIcon: CopyIcon,
  CornerDownLeftIcon: CornerDownLeftIcon,
  CpuIcon: CpuIcon,
  DatabaseBackup: DatabaseBackup,
  DatabaseZapIcon: DatabaseZapIcon,
  DevicesIcon: DevicesIcon,
  DoorClosedIcon: DoorClosedIcon,
  DotIcon: DotIcon,
  Download: Download,
  DropletIcon: DropletIcon,
  EditIcon: EditIcon,
  EllipsisIcon: EllipsisIcon,
  Expand: Expand,
  ExternalLinkIcon: ExternalLinkIcon,
  Eye: Eye,
  EyeOff: EyeOff,
  FileCheckIcon: FileCheckIcon,
  FilePenIcon: FilePenIcon,
  FilePenLineIcon: FilePenLineIcon,
  FileSpreadsheet: FileSpreadsheet,
  FileTextIcon: FileTextIcon,
  FileUpIcon: FileUpIcon,
  FileXIcon: FileXIcon,
  FlagTriangleRightIcon: FlagTriangleRightIcon,
  FolderInputIcon: FolderInputIcon,
  FolderKeyIcon: FolderKeyIcon,
  FolderOpenIcon: FolderOpenIcon,
  FolderTreeIcon: FolderTreeIcon,
  FunctionSquareIcon: FunctionSquareIcon,
  GaugeIcon: GaugeIcon,
  Gem: Gem,
  GitCompareIcon: GitCompareIcon,
  GripVerticalIcon: GripVerticalIcon,
  Hammer: Hammer,
  HandshakeIcon: HandshakeIcon,
  HardDriveIcon: HardDriveIcon,
  HashIcon: HashIcon,
  HeartMinusIcon: HeartMinusIcon,
  HeartPulseIcon: HeartPulseIcon,
  HelpCircleIcon: HelpCircleIcon,
  HistoryIcon: HistoryIcon,
  HomeIcon: HomeIcon,
  IdCardIcon: IdCardIcon,
  ImageIcon: ImageIcon,
  ImageUpIcon: ImageUpIcon,
  ImportIcon: ImportIcon,
  IncorrectRoleIcon: IncorrectRoleIcon,
  InfoIcon: InfoIcon,
  Inventory: MaterialInventoryIcon,
  IterationCw: IterationCw,
  JobLevelIcon: JobLevelIcon,
  KeyRoundIcon: KeyRoundIcon,
  LandPlotIcon: LandPlotIcon,
  LaptopIcon: LaptopIcon,
  LayersIcon: LayersIcon,
  LayoutGridIcon: LayoutGridIcon,
  LinkIcon: LinkIcon,
  ListCheckIcon: ListCheckIcon,
  ListFilterIcon: ListFilterIcon,
  ListIcon: ListIcon,
  ListOrderedIcon: ListOrderedIcon,
  ListPlusIcon: ListPlusIcon,
  ListXIcon: ListXIcon,
  Loader2Icon: Loader2Icon,
  LoaderCircleIcon: LoaderCircleIcon,
  LogicalAndIcon: LogicalAndIcon,
  LogicalOrIcon: LogicalOrIcon,
  LogOutIcon: LogOutIcon,
  Mail: Mail,
  MapPin: MapPin,
  MapPinned: MapPinned,
  MemoryStickIcon: MemoryStickIcon,
  MinusIcon: MinusIcon,
  MonitorIcon: MonitorIcon,
  MonitorSmartphoneIcon: MonitorSmartphoneIcon,
  MoreHorizontalIcon: MoreHorizontalIcon,
  MoreVerticalIcon: MoreVerticalIcon,
  MouseIcon: MouseIcon,
  MoveDownRightIcon: MoveDownRightIcon,
  MoveRightIcon: MoveRightIcon,
  MoveUpRightIcon: MoveUpRightIcon,
  NetworkIcon: NetworkIcon,
  NoLogoIcon: NoLogoIcon,
  OperationTaskIcon: OperationTaskIcon,
  OrganizationIcon: OrganizationIcon,
  OriginalIdIcon: OriginalIdIcon,
  OriginalManagerIcon: OriginalManagerIcon,
  OriginalPlacementCheckIcon: OriginalPlacementCheckIcon,
  OriginalRoleIcon: OriginalRoleIcon,
  OsAndroidIcon: OsAndroidIcon,
  OsChromeIcon: OsChromeIcon,
  OsLinuxIcon: OsLinuxIcon,
  OsMacosIcon: OsMacosIcon,
  OsOthersIcon: OsOthersIcon,
  OsWindowsIcon: OsWindowsIcon,
  PackageMinus: PackageMinusIcon,
  PackageOpen: PackageOpen,
  PackagePlus: PackagePlusIcon,
  PanelLeftCloseIcon: PanelLeftCloseIcon,
  PanelLeftOpenIcon: PanelLeftOpenIcon,
  Paperclip: Paperclip,
  PencilIcon: PencilIcon,
  PeopleIcon: PeopleIcon,
  Phone: Phone,
  PlaneLandingIcon: PlaneLandingIcon,
  PlaneTakeoffIcon: PlaneTakeoffIcon,
  PlusCircle: PlusCircle,
  PlusIcon: PlusIcon,
  PointerIcon: PointerIcon,
  PortAudioIcon: PortAudioIcon,
  PortDisplayPortIcon: PortDisplayPortIcon,
  PortDviIcon: PortDviIcon,
  PortHdmiIcon: PortHdmiIcon,
  PortLanIcon: PortLanIcon,
  PortMiniDisplayPortIcon: PortMiniDisplayPortIcon,
  PortThunderboltIcon: PortThunderboltIcon,
  PortUsbMicroBIcon: PortUsbMicroBIcon,
  PortUsbMiniIcon: PortUsbMiniIcon,
  PortUsbTypeAIcon: PortUsbTypeAIcon,
  PortUsbTypeBIcon: PortUsbTypeBIcon,
  PortUsbTypeCIcon: PortUsbTypeCIcon,
  PortVgaIcon: PortVgaIcon,
  PrinterIcon: PrinterIcon,
  ProductIcon: ProductIcon,
  ProductLogoSmallPlaces: ProductLogoSmallPlaces,
  QrCodeIcon: QrCodeIcon,
  QuickReferenceAll: MaterialQuickReferenceAll,
  RadioIcon: RadioIcon,
  RecycleIcon: RecycleIcon,
  RedoDotIcon: RedoDotIcon,
  RefreshCcwDotIcon: RefreshCcwDotIcon,
  RefreshCwIcon: RefreshCwIcon,
  Repeat2Icon: Repeat2Icon,
  RocketIcon: RocketIcon,
  RoleIcon: RoleIcon,
  RouterIcon: RouterIcon,
  SatelliteDishIcon: SatelliteDishIcon,
  SaveIcon: SaveIcon,
  ScanBarcodeIcon: ScanBarcodeIcon,
  SearchIcon: SearchIcon,
  SearchSlashIcon: SearchSlashIcon,
  SearchXIcon: SearchXIcon,
  SendIcon: SendIcon,
  SendHorizontalIcon: SendHorizontalIcon,
  ServerIcon: ServerIcon,
  Settings2Icon: Settings2Icon,
  SettingsIcon: SettingsIcon,
  SettingsLucideIcon: SettingsLucideIcon,
  Share2: Share2,
  ShieldCheckIcon: ShieldCheckIcon,
  ShieldEllipsisIcon: ShieldEllipsisIcon,
  ShieldIcon: ShieldIcon,
  ShieldXIcon: ShieldXIcon,
  ShoppingCart: ShoppingCart,
  SlidersHorizontal: SlidersHorizontal,
  SmartphoneIcon: SmartphoneIcon,
  Square: Square,
  SquareArrowOutUpRightIcon: SquareArrowOutUpRightIcon,
  SquareArrowUpRightIcon: SquareArrowUpRightIcon,
  SquareAsterisk: SquareAsterisk,
  SquareCheckBig: SquareCheckBig,
  SquareDot: SquareDot,
  SquareUser: SquareUser,
  StampIcon: StampIcon,
  StatusIcon: StatusIcon,
  StickyNoteIcon: StickyNoteIcon,
  StretchHorizontalIcon: StretchHorizontalIcon,
  Table2Icon: Table2Icon,
  TabletSmartphoneIcon: TabletSmartphoneIcon,
  TagIcon: TagIcon,
  ThumbsUpIcon: ThumbsUpIcon,
  Trash2Icon: Trash2Icon,
  TrendingDownIcon: TrendingDownIcon,
  TrendingUpIcon: TrendingUpIcon,
  TriangleAlertIcon: TriangleAlertIcon,
  Truck: Truck,
  User2Icon: User2Icon,
  UserIcon: UserIcon,
  UserMinusIcon: UserMinusIcon,
  UserPlusIcon: UserPlusIcon,
  UserRoundCheckIcon: UserRoundCheckIcon,
  UserRoundCogIcon: UserRoundCogIcon,
  UserRoundIcon: UserRoundIcon,
  UserRoundMinusIcon: UserRoundMinusIcon,
  UserRoundPlusIcon: UserRoundPlusIcon,
  UserRoundSearchIcon: UserRoundSearchIcon,
  UserRoundXIcon: UserRoundXIcon,
  UsersRoundIcon: UsersRoundIcon,
  ViewIcon: ViewIcon,
  WaypointsIcon: WaypointsIcon,
  WorkArrangementIcon: WorkArrangementIcon,
  WrenchIcon: WrenchIcon,
  XIcon: XIcon,
  XOctagonIcon: XOctagonIcon,
} as const;

export type IconName = keyof typeof IconMap;
